module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAYAAADED76LAAAAAXNSR0IArs4c6QAAAJ1JREFUKFNjZGBgYLj45L8MAwND/38GBgcQn5GBYc///wwlBrKMTxlBkn//MZzfdvm3yPF7f0DyDJZKLAxeuqxvmJkYDEEKVm+++Dtkz3WIJAy4aLIw+OqzrmC88OT/6+r130W+/kSRZ+BmZ2BoDeR8Q4SCR/9XbLn8OxybFT66rCsJOxLmzf//GHoYmBicwS75x7CXkYmhRF+G8QkAt05TmTeywO0AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/frontierPage/article-title-ellipse.png
// module id = FFA2
// module chunks = 0